/* ============================================================
   kit50-juego.js — "Crea tu kit de 50 ml" gamificado.
   Solo lo carga la sección minimal-coleccion-kit-juego (plantilla collection.minimal-coleccion-50-ml).
   1) El "+" de las tarjetas NO agrega al carrito: elige la fragancia para el estuche (captura en document,
      antes que minimal-coleccion.js). Selección guardada en localStorage (misma llave que la barra anterior).
   2) Juego: estuche de N espacios con la foto de cada fragancia, nivel por fragancia, precio normal tachado
      vs precio del kit, foto que vuela al estuche, celebración + confeti al completar.
   3) Completar: multi-add (/cart/add.js items[]) + burbuja/drawer del tema + abre el drawer.
   Precio real = 2 descuentos automáticos que no se suman (Shopify aplica el mayor): 1 kit (3+) y 2 kits (6+ de la
   colección del descuento de 2 kits). Antes de agregar solo, se calcula cuánto suman de verdad las 3 elegidas con lo
   que ya hay en el carrito: si dan el precio del kit se agregan y se abre el drawer; si no, se avisa y decide el cliente.
   Respeta prefers-reduced-motion. Prefijo .k50-.
   ============================================================ */
(function () {
  'use strict';
  var el = document.querySelector('[data-k50]');
  if (!el || el.__k50) return;
  el.__k50 = true;

  var ds = el.dataset;
  var TARGET = parseInt(ds.target, 10) || 3;
  var UNIT = parseInt(ds.unit, 10) || 109900;
  var KIT = parseInt(ds.kit, 10) || 168900;
  var SAVE = Math.max(0, UNIT * TARGET - KIT);        // descuento de 1 kit
  var DESC2 = parseInt(ds.desc2, 10) || 0;              // descuento de 2 kits (0 = no existe)
  var KEY = 'mc-kit-' + (ds.key || 'default');
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var q = function (s, c) { return (c || el).querySelector(s); };

  function fmt(v) { return '$' + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function fill(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

  /* Textos con {variables}: los defaults van aquí (Liquid no acepta llaves dentro de un default) */
  var MSG = {
    0: ds.msg0 || 'Elige {objetivo} fragancias de 50 ml y llévalas por {kit}',
    1: ds.msg1 || '¡Buena elección! Elige {faltan} más y ahorra {ahorro}',
    2: ds.msg2 || '¡Solo {faltan} más y tu kit queda en {kit}!',
    full: ds.msgfull || '¡Kit completo! Ahorras {ahorro} · {objetivo} por {kit}',
    cart1: ds.msgcart || 'Ya tienes 1 kit en el carrito. Arma el 2º también por {kit}',
    cart2: 'Ya tienes 2 kits en el carrito. El precio de kit aplica hasta 2 kits por pedido',
    tope: 'Estas {objetivo} suman {precio}: el precio de kit aplica hasta 2 kits por pedido',
    noaplica: 'Estas {objetivo} suman {precio}: {nombres} no participa en el 2º kit. Cámbiala para pagar {kit}'
  };
  var LEVELS = (ds.levels || 'Primera elegida,Casi listo,Kit completo').split(',').map(function (s) { return s.trim(); });
  function lvName(n) { return n >= TARGET ? (LEVELS[LEVELS.length - 1] || 'Kit completo') : (LEVELS[n - 1] || ''); }

  /* ---------- Estado ---------- */
  function load() { try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v.slice(0, TARGET) : []; } catch (e) { return []; } }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(selected)); } catch (e) {} }
  var selected = load();
  var agregando = false;
  // Carrito: fragancias de esta colección (kit) y de la colección del descuento de 2 kits (x6)
  var carro = { kit: 0, x6: 0, ok: false };
  var idsKit = null, idsX6 = null;
  function enX6(pid) { return !DESC2 || !idsX6 || !pid || idsX6.indexOf(',' + pid + ',') !== -1; }
  function descuento(kit, x6) { return Math.max(kit >= TARGET ? SAVE : 0, DESC2 && x6 >= TARGET * 2 ? DESC2 : 0); }
  function kitsEnCarrito() { var d = descuento(carro.kit, carro.x6); return d === 0 ? 0 : (DESC2 && d === DESC2 ? 2 : 1); }
  // ¿Cuánto suman de verdad estas fragancias si se agregan al carrito actual?
  function evaluar(lote) {
    var x = lote.filter(function (s) { return enX6(s.pid); }).length;
    var costo = UNIT * lote.length - (descuento(carro.kit + lote.length, carro.x6 + x) - descuento(carro.kit, carro.x6));
    var fuera = lote.filter(function (s) { return !enX6(s.pid); });
    var motivo = costo === KIT ? '' : (kitsEnCarrito() >= 2 || !DESC2 ? 'tope' : (fuera.length ? 'noaplica' : 'tope'));
    return { costo: costo, esKit: costo === KIT, motivo: motivo, fuera: fuera };
  }
  function nombres(list) { return list.map(function (s) { return (s.title || '').replace(/^S\d{3}\s*/, ''); }).join(', '); }
  function isSel(vid) { vid = String(vid); return selected.some(function (s) { return String(s.vid) === vid; }); }

  /* ---------- DOM ---------- */
  var caseEl = q('[data-k50-case]');
  var slots = el.querySelectorAll('[data-k50-slot]');
  var titleEl = q('[data-k50-title]');
  var msgEl = q('[data-k50-msg]');
  var normalEl = q('[data-k50-normal]');
  var kitEl = q('[data-k50-kitprice]');
  var cta = q('[data-k50-cta]');
  var stepsEl = q('[data-k50-steps]');
  var fx = document.querySelector('[data-k50-fx]');
  var toast = document.querySelector('[data-k50-toast]');
  var mini = document.querySelector('[data-k50-mini]');

  function restart(node, cls) { if (!node) return; node.classList.remove(cls); void node.offsetWidth; node.classList.add(cls); }

  function datos(n, ev) {
    return { objetivo: TARGET, kit: fmt(KIT), ahorro: fmt(SAVE), faltan: Math.max(0, TARGET - n), normal: fmt(UNIT * TARGET),
      precio: ev ? fmt(ev.costo) : '', nombres: ev ? nombres(ev.fuera) : '' };
  }

  function draw() {
    var n = selected.length, full = n >= TARGET;
    // Estuche
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i], it = selected[i];
      s.classList.toggle('is-filled', !!it);
      s.classList.toggle('is-next', !it && i === n);
      s.disabled = !it;
      if (it) {
        s.innerHTML = (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '<span class="k50__slot-code">' + esc((it.title || '').split(' ')[0]) + '</span>') +
          '<span class="k50__slot-x" aria-hidden="true"></span>';
        s.setAttribute('aria-label', 'Quitar ' + (it.title || 'fragancia') + ' del kit');
      } else {
        s.innerHTML = '<span class="k50__slot-num" aria-hidden="true">' + (i + 1) + '</span>';
        s.removeAttribute('aria-label');
      }
    }
    // Textos
    var kits = kitsEnCarrito();
    var ev = full ? evaluar(selected.slice(0, TARGET)) : null;
    var esKit = !ev || ev.esKit;
    var t0 = titleEl ? (titleEl.getAttribute('data-k50-t0') || titleEl.textContent) : '';
    var segundo = kits === 1 ? '2º kit · ' : '';
    if (titleEl) titleEl.textContent = n === 0 ? (kits ? kits + (kits === 1 ? ' kit' : ' kits') + ' en tu carrito' : t0) : (segundo + 'Nivel ' + Math.min(n, TARGET) + ' · ' + lvName(n));
    var m;
    if (n === 0) m = kits === 2 ? MSG.cart2 : (kits === 1 ? (DESC2 ? MSG.cart1 : MSG.cart2) : MSG[0]);
    else if (full) m = esKit ? MSG.full : MSG[ev.motivo];
    else if (TARGET - n === 1) m = MSG[2];
    else m = MSG[1];
    if (msgEl) msgEl.textContent = fill(m, datos(n, ev));
    // Precio: normal tachado (lo que costaría suelto) vs lo que de verdad van a pagar
    if (normalEl) { normalEl.textContent = fmt(UNIT * TARGET); normalEl.hidden = !esKit; }
    if (kitEl) kitEl.textContent = esKit ? fmt(KIT) : fmt(ev.costo);
    // CTA
    if (cta && !agregando) {
      cta.disabled = !full && !(n === 0 && kits > 0);
      cta.textContent = full ? (esKit ? 'Agregar mi kit' : 'Agregar ' + fmt(ev.costo)) : (n === 0 && kits > 0 ? 'Ver mi carrito' : 'Faltan ' + (TARGET - n));
    }
    // Pasos
    if (stepsEl) {
      stepsEl.setAttribute('aria-valuenow', n);
      stepsEl.querySelectorAll('.k50__step').forEach(function (li, i) {
        li.classList.toggle('is-on', i < n);
        li.classList.toggle('is-next', i === n);
      });
    }
    el.classList.toggle('is-full', full && esKit);
    el.classList.toggle('is-zero', n === 0);
    // "+" de la grilla
    document.querySelectorAll('[data-mc-add]').forEach(function (b) {
      var sel = isSel(b.getAttribute('data-variant-id'));
      b.classList.toggle('is-added', sel);
      b.classList.toggle('mc-kit-selected', sel);
      b.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
  }
  if (titleEl) titleEl.setAttribute('data-k50-t0', titleEl.textContent);

  /* ---------- Efectos ---------- */
  var toastTimer;
  function showToast(kicker, title, sub, big) {
    if (!toast) return;
    q('[data-k50-tk]', toast).textContent = kicker;
    q('[data-k50-tt]', toast).textContent = title;
    q('[data-k50-ts]', toast).textContent = sub;
    toast.classList.toggle('is-big', !!big);
    toast.hidden = false;
    restart(toast, 'is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, big ? 3200 : 1900);
  }
  function hideToast() { if (toast && !toast.hidden) { toast.classList.remove('is-in'); toast.hidden = true; } }

  var miniTimer;
  function showMini(txt) {
    if (!mini || !txt) return;
    mini.textContent = txt;
    mini.hidden = false;
    restart(mini, 'is-in');
    clearTimeout(miniTimer);
    miniTimer = setTimeout(function () { mini.hidden = true; mini.classList.remove('is-in'); }, 2800);
  }

  var COLORS = ['#000000', '#FFFFFF', '#C9A24B', '#E8D3A2', '#8A8A8A'];
  function confetti(count) {
    if (RM || !fx || ds.celebrar === '0') return;
    var r = caseEl ? caseEl.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight - 60, width: 0, height: 0 };
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2, vw = innerWidth, frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var s = document.createElement('i');
      var ang = (-90 + (Math.random() * 110 - 55)) * Math.PI / 180;
      var dist = 140 + Math.random() * Math.min(420, innerHeight * 0.55);
      var px = Math.cos(ang) * dist + (vw / 2 - ox) * Math.random() * 0.8, py = Math.sin(ang) * dist;
      s.className = 'k50-fx__p' + (Math.random() < 0.35 ? ' is-round' : '');
      s.style.left = ox + 'px'; s.style.top = oy + 'px';
      s.style.background = COLORS[i % COLORS.length];
      s.style.setProperty('--x', px.toFixed(1) + 'px');
      s.style.setProperty('--y', py.toFixed(1) + 'px');
      s.style.setProperty('--y2', (py + 120 + Math.random() * 160).toFixed(1) + 'px');
      s.style.setProperty('--r', (Math.random() * 720 - 360).toFixed(0) + 'deg');
      s.style.setProperty('--d', (Math.random() * 120).toFixed(0) + 'ms');
      s.style.setProperty('--t', (1100 + Math.random() * 700).toFixed(0) + 'ms');
      frag.appendChild(s);
    }
    fx.appendChild(frag);
    var batch = Array.prototype.slice.call(fx.children, -count);
    setTimeout(function () { batch.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); }); }, 2100);
  }

  /* La foto de la fragancia vuela desde la tarjeta hasta su espacio en el estuche */
  function fly(fromImg, slotIdx, done) {
    var slot = slots[slotIdx];
    if (RM || !fromImg || !slot || !document.body.animate) { done(); return; }
    var a = fromImg.getBoundingClientRect(), b = slot.getBoundingClientRect();
    if (!a.width || !b.width) { done(); return; }
    var f = document.createElement('img');
    f.className = 'k50-fly';
    f.src = fromImg.currentSrc || fromImg.src;
    f.alt = '';
    var size = Math.min(a.width, 120);
    f.style.width = size + 'px';
    f.style.left = (a.left + a.width / 2) + 'px';
    f.style.top = (a.top + a.height / 2) + 'px';
    document.body.appendChild(f);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var k = b.width / size;
    var anim = f.animate([
      { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
      { transform: 'translate(calc(-50% + ' + dx * 0.45 + 'px), calc(-50% + ' + (dy * 0.45 - 70) + 'px)) scale(' + Math.max(k, 0.55) + ')', opacity: 1, offset: 0.5 },
      { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(' + k + ')', opacity: 0.9 }
    ], { duration: 650, easing: 'cubic-bezier(.45,0,.55,1)' });
    var finished = false;
    var end = function () { if (finished) return; finished = true; if (f.parentNode) f.parentNode.removeChild(f); done(); };
    anim.onfinish = end;
    setTimeout(end, 850);
  }

  /* ---------- Elegir / quitar ---------- */
  var enVuelo = {}, ultimoToque = {};
  function pick(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (!vid || enVuelo[vid]) return;
    // Doble toque sin querer (< 0,6 s) sobre el mismo "+": cuenta como uno solo
    var ahora = Date.now();
    if (ultimoToque[vid] && ahora - ultimoToque[vid] < 600) return;
    ultimoToque[vid] = ahora;
    var card = btn.closest('[data-mc-card]');
    if (isSel(vid)) { if (!agregando) quitar(vid); return; }
    if (selected.length >= TARGET) {
      restart(caseEl, 'is-shake');
      showMini('Tu kit ya tiene ' + TARGET + '. Toca una del estuche para cambiarla');
      return;
    }
    var nameEl = card && card.querySelector('.mc-card__name');
    var img = card && card.querySelector('.mc-card__img--main');
    var item = {
      vid: vid,
      pid: card ? card.getAttribute('data-product-id') : '',
      title: nameEl ? (nameEl.textContent || '').trim() : '',
      img: img ? (img.currentSrc || img.src || '').replace(/width=\d+/, 'width=180') : ''
    };
    var idx = selected.length;
    selected.push(item);
    persist();
    // El "+" se marca de una vez; el estuche se llena cuando llega la foto
    btn.classList.add('is-added', 'mc-kit-selected');
    enVuelo[vid] = true;
    fly(img, idx, function () {
      delete enVuelo[vid];
      if (!isSel(vid)) { draw(); return; } // se quitó mientras volaba
      idx = Math.max(0, selected.findIndex(function (s) { return String(s.vid) === String(vid); }));
      draw();
      restart(slots[idx], 'is-pop');
      var n = selected.length;
      try { if (navigator.vibrate) navigator.vibrate(n >= TARGET ? [30, 50, 70] : 25); } catch (e) {}
      if (n >= TARGET) {
        // Se decide con el carrito recién leído: ¿estas 3 salen a precio de kit?
        revisarCarrito().then(function () {
          if (selected.length < TARGET || agregando) return;
          var ev = evaluar(selected.slice(0, TARGET));
          draw();
          if (ev.esKit) {
            var dos = kitsEnCarrito() === 1;
            restart(el, 'is-levelup');
            showToast('Nivel ' + TARGET + ' · ' + (dos ? '2º kit desbloqueado' : 'Kit desbloqueado'), dos ? '2 kits' : lvName(TARGET),
              TARGET + ' fragancias por ' + fmt(KIT) + ' · Ahorras ' + fmt(SAVE), true);
            confetti(90);
            // 3ª fragancia: se agrega el kit y se abre el carrito lateral
            setTimeout(function () { if (selected.length >= TARGET && evaluar(selected.slice(0, TARGET)).esKit) agregarKit('auto'); }, RM ? 300 : 1100);
          } else {
            // No sale a precio de kit (tope de 2 kits o fragancia que no participa): no se agrega solo
            restart(caseEl, 'is-shake');
            showMini(fill(MSG[ev.motivo], datos(TARGET, ev)));
            setTimeout(function () { restart(cta, 'is-nudge'); }, RM ? 0 : 300);
          }
        });
      } else {
        restart(el, 'is-bump');
        showToast('Nivel ' + n, lvName(n), 'Te ' + (TARGET - n === 1 ? 'falta 1' : 'faltan ' + (TARGET - n)) + ' para ahorrar ' + fmt(SAVE), false);
      }
    });
  }
  function quitar(vid) {
    selected = selected.filter(function (s) { return String(s.vid) !== String(vid); });
    persist();
    draw();
  }

  // "+" de la grilla: antes que el add-to-cart directo de minimal-coleccion.js
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mc-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    pick(btn);
  }, true);

  slots.forEach(function (s, i) {
    s.addEventListener('click', function () { if (selected[i] && !agregando) quitar(selected[i].vid); });
  });

  /* ---------- Carrito (helpers del tema) ---------- */
  function refreshBubble(sec) {
    try {
      if (sec && sec['cart-icon-bubble']) {
        var p = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
        var t = document.getElementById('cart-icon-bubble');
        var x = p.querySelector('#shopify-section-cart-icon-bubble') || p.querySelector('.shopify-section');
        if (t && x) t.innerHTML = x.innerHTML;
      }
    } catch (e) {}
  }
  function updateDrawer(sec) {
    try {
      if (sec && sec['cart-drawer']) {
        var p = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
        var t = document.querySelector('cart-drawer');
        var x = p.querySelector('cart-drawer');
        if (t && x) { t.classList.toggle('is-empty', x.classList.contains('is-empty')); t.innerHTML = x.innerHTML; }
      }
    } catch (e) {}
  }
  function openDrawer(trigger) {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(trigger); return; }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  // Ids de una colección (cacheados 20 min en sessionStorage)
  function idsDe(handle) {
    if (!handle) return Promise.resolve(null);
    var key = 'k50ids:' + handle;
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 20 * 60 * 1000) return Promise.resolve(c.p); } catch (e) {}
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (d) { var p = ',' + (d.products || []).map(function (x) { return x.id; }).join(',') + ','; try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {} return p; });
  }
  // Cuenta en el carrito las fragancias del kit y las que participan en el descuento de 2 kits
  var revisando = null;
  function revisarCarrito() {
    if (revisando) return revisando;
    revisando = Promise.all([
      idsKit ? Promise.resolve(idsKit) : idsDe(ds.handle),
      idsX6 || !DESC2 ? Promise.resolve(idsX6) : idsDe(ds.handle2 || ''),
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
    ]).then(function (res) {
      idsKit = res[0] || idsKit; idsX6 = res[1] || idsX6;
      var k = 0, x = 0;
      (res[2].items || []).forEach(function (it) {
        if (idsKit && idsKit.indexOf(',' + it.product_id + ',') !== -1) k += it.quantity;
        if (idsX6 && idsX6.indexOf(',' + it.product_id + ',') !== -1) x += it.quantity;
      });
      var cambio = k !== carro.kit || x !== carro.x6 || !carro.ok;
      carro = { kit: k, x6: x, ok: true };
      if (cambio && !agregando) draw();
      return carro;
    }).catch(function () { return carro; }).then(function (c) { revisando = null; return c; });
    return revisando;
  }

  /* Espera a que el carrito deje de cambiar (cart-rewards.js puede tocarlo en segundo plano) */
  function cartEstable(maxMs) {
    var t0 = Date.now(), last = null, since = 0;
    function poll() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); })
        .then(function (c) {
          var sig = c.item_count + ':' + c.total_price;
          if (sig !== last) { last = sig; since = Date.now(); }
          if (Date.now() - since >= 400 || Date.now() - t0 >= maxMs) return c;
          return new Promise(function (ok) { setTimeout(ok, 150); }).then(poll);
        });
    }
    return poll();
  }
  /* HTML fresco del drawer y la burbuja (Section Rendering API) */
  function refrescarSecciones() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sec) { if (sec) { refreshBubble(sec); updateDrawer(sec); } })
      .catch(function () {});
  }

  /* Agrega el kit al carrito y abre el drawer. origen: 'auto' (3ª fragancia) o 'boton'. */
  function agregarKit(origen) {
    if (agregando || selected.length < TARGET) return;
    agregando = true;
    if (cta) { cta.classList.add('is-loading'); cta.textContent = 'Agregando…'; }
    var lote = selected.slice(0, TARGET);
    var items = lote.map(function (s) { return { id: Number(s.vid), quantity: 1 }; });
    var ev = evaluar(lote);
    var precioKit = ev.esKit;
    var dos = precioKit && kitsEnCarrito() === 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) { var err = new Error('add'); err.data = d; throw err; } return d; }); })
      .then(function (data) {
        refreshBubble(data.sections);
        updateDrawer(data.sections);
        // Solo se vacía lo que se agregó (si el cliente tocó el estuche mientras tanto, no se pierde nada)
        var ids = lote.map(function (s) { return String(s.vid); });
        selected = selected.filter(function (s) { return ids.indexOf(String(s.vid)) === -1; });
        persist();
        if (cta) cta.classList.remove('is-loading');
        draw();
        if (origen === 'boton' || precioKit) {
          showToast('¡Listo!', precioKit ? (dos ? '2º kit agregado' : 'Kit agregado') : 'Agregadas',
            precioKit ? (dos ? '2 kits por ' + fmt(KIT * 2) : 'Tu kit de ' + TARGET + ' por ' + fmt(KIT)) + ' ya está en el carrito' : 'Suman ' + fmt(ev.costo), true);
        }
        return cartEstable(2500).then(function () { return Promise.all([refrescarSecciones(), revisarCarrito()]); });
      })
      .then(function () {
        agregando = false;
        draw();
        setTimeout(function () { hideToast(); openDrawer(cta); }, RM ? 0 : 250);
      })
      .catch(function (err) {
        agregando = false;
        if (cta) cta.classList.remove('is-loading');
        draw();
        var d = err && err.data;
        showMini((d && (d.description || d.message)) || 'No se pudo agregar el kit. Intenta de nuevo.');
        revisarCarrito();
      });
  }

  if (cta) {
    cta.addEventListener('click', function () {
      if (selected.length === 0 && kitsEnCarrito() > 0) { openDrawer(cta); return; }
      agregarKit('boton');
    });
    cta.addEventListener('animationend', function () { cta.classList.remove('is-nudge'); });
  }

  // Breadcrumb -> 50 ML (igual que la barra anterior)
  var bc = document.querySelector('.mc-breadcrumb span[aria-current]');
  if (bc) bc.textContent = '50 ML';

  // Re-marcar "+" cuando "Ver más" o el orden por ciudad agregan/mueven tarjetas
  var stream = document.querySelector('[data-mc-stream]');
  if (stream && 'MutationObserver' in window && !designMode) {
    var raf = 0;
    new MutationObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }).observe(stream, { childList: true });
  }

  // Cambios del carrito hechos en el drawer (quitar fragancias del kit) → re-evaluar "kit en carrito"
  var revT;
  function programarRevision() { clearTimeout(revT); revT = setTimeout(function () { if (!agregando) revisarCarrito(); }, 350); }
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(programarRevision).observe(drawer, { childList: true, subtree: true });
  }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (/\/cart\/(add|change|update|clear)/.test(e.name)) programarRevision(); });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }

  function setH() { document.documentElement.style.setProperty('--k50-h', el.offsetHeight + 'px'); }

  /* ---------- Arranque ---------- */
  el.hidden = false;
  document.body.classList.add('mc-kit-active');
  draw();
  setH();
  if ('ResizeObserver' in window) new ResizeObserver(setH).observe(el);
  revisarCarrito();
  window.addEventListener('pageshow', function (e) { if (e.persisted) { selected = load(); draw(); revisarCarrito(); } });
})();
